<template>
    <bottom-sheet>
        <template #title>
            <span>Disable {{ currentAsset.symbol }}</span>
        </template>

        <div class="sheet-notice sheet-notice-danger">
            Deletes <span class="mono">{{ formatAmount(writeOffSummary.value) }}</span> of open positions
            and disables {{ currentAsset.symbol }}. Conviction drops to Snoozed.
        </div>

        <div v-if="leftoverShares > 0" class="sheet-notice sheet-notice-caution">
            <span class="mono">{{ formatHoldings(leftoverShares) }}</span> shares in buckets stay as they are.
        </div>

        <form autocomplete="off" @submit.prevent="onSubmit">
            <sheet-section label="Exit">
                <form-row label="Price">
                    <input v-model.number="form.exitPrice" type="number" step="any" inputmode="decimal" class="sheet-input">
                </form-row>
            </sheet-section>
        </form>

        <template #actions>
            <button type="button" class="sheet-btn sheet-btn-danger" :disabled="busy || !form.exitPrice" @click="onSubmit">
                <b-spinner v-if="busy" small type="grow" />
                <template v-else>
                    <b-icon icon="trash" aria-hidden="true" />
                    Disable {{ currentAsset.symbol }}
                </template>
            </button>
        </template>

        <confirm-prompt
            :visible="confirmVisible"
            :title="`Disable ${currentAsset.symbol}`"
            :message="confirmMessage"
            :confirm-label="`Disable ${currentAsset.symbol}`"
            confirm-variant="btn-danger"
            @confirm="confirmDisable"
            @cancel="cancelDisable"
        />
    </bottom-sheet>
</template>

<script>

import apiMixin from '@/mixins/api';
import formatter from '@/mixins/formatter';
import ConfirmPrompt from '@/components/overlays/ConfirmPrompt.vue';
import BottomSheet from '@/components/sheet/BottomSheet.vue';
import SheetSection from '@/components/sheet/SheetSection.vue';
import FormRow from '@/components/sheet/FormRow.vue';

export default {
    name: 'DisableAsset',
    mixins: [apiMixin, formatter],
    props: ['currentAsset', 'onDone'],
    components: { ConfirmPrompt, BottomSheet, SheetSection, FormRow },
    data() {
        return {
            form: {
                exitPrice: this.currentAsset.price,
            },
            busy: false,
            confirmVisible: false,
        }
    },
    computed: {
        writeOffSummary() {
            const cached = this.currentAsset.cached_stats;
            if (!cached) return { value: 0 };

            return {
                value: cached.open_positions_value || 0,
            };
        },
        leftoverShares() {
            const balances = this.currentAsset.balances || [];
            return balances.reduce((total, balance) => total + balance.shares, 0);
        },
        confirmMessage() {
            return `Disable ${this.currentAsset.symbol}? Deletes ${this.formatAmount(this.writeOffSummary.value)} of open positions.`;
        },
    },
    methods: {
        onSubmit() {
            if (this.busy) return;
            this.confirmVisible = true;
        },
        cancelDisable() {
            this.confirmVisible = false;
        },
        async confirmDisable() {
            this.confirmVisible = false;

            if (this.busy) return;
            this.busy = true;

            const response = await this.apiPost(
                `/api/asset/${this.currentAsset.symbol}/disable`,
                { exit_price: this.form.exitPrice }
            );

            this.busy = false;

            if (!response) return;

            this.$store.dispatch('updateAssets', [response.data.asset]);
            // the server regenerates the cache at disable time; quote what it actually wrote off
            this._apiSuccessToast(
                `Wrote off ${response.data.position_count} positions (${this.formatAmount(response.data.value_released)}).`
            );
            this.$FModal.hide();
            if (this.onDone) this.onDone();
        },
    },
};
</script>
